export function isAccountMature(date: Date): boolean {
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  return date.getTime() >= threeMonthsAgo.getTime();
}
